import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import CheckboxInputButton from '../components/CheckboxInputButton'
import ContinueButton from '../components/ContinueButton'
import Heading from '../components/Heading'
import PageLayout from '../components/PageLayout'
import { AnswerType } from '../types'

export default function MultipleChoiceQuestionPage({
  answers,
  title,
  subtitle,
  translationInterpolation,
}: {
  answers: AnswerType[]
  title: string
  subtitle: string
  /** Passed to `t()` for title/subtitle (e.g. `{{noun}}`) */
  translationInterpolation?: Record<string, string>
}) {
  const [selectedAnswers, setSelectedAnswers] = useState<string[]>([])

  const { t } = useTranslation()

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked

    const answer = event.target.value

    if (checked) {
      setSelectedAnswers([...selectedAnswers, answer])
    } else {
      setSelectedAnswers(
        selectedAnswers.filter((selectedAnswer) => selectedAnswer !== answer),
      )
    }
  }

  return (
    <PageLayout>
      <div className="shrink-0">
        <Heading
          subtitle={
            subtitle ? t(subtitle, translationInterpolation) : undefined
          }
          title={t(title, translationInterpolation)}
        />
      </div>

      <div className="flex grow flex-col">
        <Form className="flex grow flex-col gap-14" method="post">
          <div className="flex grow flex-col justify-center gap-4">
            {answers.map((answer) => (
              <CheckboxInputButton
                emoji={answer.emoji}
                id={t(answer.title, { lng: 'en' })}
                key={t(answer.title, { lng: 'en' })}
                name={t(title, { lng: 'en' })}
                onChange={handleCheckBoxChange}
                subtitle={answer.subtitle ? t(answer.subtitle) : undefined}
                title={t(answer.title)}
                value={answer.value}
              />
            ))}
          </div>

          <div
            className={twMerge(
              'sticky bottom-14 shrink-0 transition-all duration-300',
              selectedAnswers.length === 0
                ? 'invisible opacity-0'
                : 'visible opacity-100',
            )}
          >
            <ContinueButton disabled={selectedAnswers.length === 0} />
          </div>
        </Form>
      </div>
    </PageLayout>
  )
}
